@if (showDetails) {
  <mat-password-strength
    #passwordComponent 
    [password]="form.formGroup.value?.[this.passwordKey]">
  </mat-password-strength>
  <mat-password-strength-info
    [passwordComponent]="passwordComponent"
    lowerCaseCriteriaMsg="{{'password must contain at least one lower character' | translate }}"
    upperCaseCriteriaMsg="{{'password must contain at least one upper character' | translate }}"
    digitsCriteriaMsg="{{'password must contain at least one digit character' | translate }}"
    specialCharsCriteriaMsg="{{'password must contain at least one special character' | translate }}"
    minCharsCriteriaMsg="{{'password must contain at least 8 characters' | translate }}">
  </mat-password-strength-info>
}
